export default {
  ajaxError: '连接出错，稍后重试'
}
